import { render } from "./alert-modal.component.vue?vue&type=template&id=d9c5c5a0&ts=true"
import script from "./alert-modal.component.vue?vue&type=script&lang=ts"
export * from "./alert-modal.component.vue?vue&type=script&lang=ts"

import "./alert-modal.component.vue?vue&type=style&index=0&id=d9c5c5a0&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__